import { ApolloClient, InMemoryCache, createHttpLink } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { AuthClient } from './api/ApiClientBase';

let graphqlUri = ''; 
let apolloClient: ApolloClient<any> | null = null;

export function setGraphqlUri(uri: string) {
  graphqlUri = uri;
  apolloClient = null;
}

export function getApolloClient() {
  if (!apolloClient) {
    const httpLink = createHttpLink({ uri: graphqlUri });

    const authLink = setContext((_, { headers }) => {
      const token = AuthClient.accessToken;
      return {
        headers: {
              ...headers,
              tenant: localStorage.getItem('tenantName'),
          authorization: token ? `Bearer ${token}` : '',
        },
      };
    });

    apolloClient = new ApolloClient({
      link: authLink.concat(httpLink),
      cache: new InMemoryCache(),
    });
  }
  return apolloClient;
}
